import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  origin_uf: string;
  origin_ibge: string;
  destination_uf: string;
  destination_ibge: string;
  status: string;
  carrier_id: string;
}>;

export type PaginationControl = {
  page: number;
  limit: number;
};

type State = {
  filters: Filters;
  paginationControl: PaginationControl;
}

type Actions = {
  updateFilters: (filters: Filters) => void;
  updatePaginationControl: (paginationControl: Partial<PaginationControl>) => void;
  clearState: () => void;
}

type Options = {
  persisted?: boolean;
}

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const PERSISTENCE_OPTIONS = {
  name: 'evonik-transport-routes-search-params',
  version: 1,
};

const store = create<State & Actions>(
  (set) => ({
    ...getInitialState(),
    updateFilters: (filters) => set({ filters }),
    updatePaginationControl: (paginationControl) => {
      return set((state) => ({
        paginationControl: {
          ...state.paginationControl,
          ...paginationControl,
        },
      }));
    },
    clearState: () => set(getInitialState()),
  }),
);

const persistedStore = create(
  persist<State & Actions>(
    (set) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updatePaginationControl: (paginationControl) => {
        return set((state) => ({
          paginationControl: {
            ...state.paginationControl,
            ...paginationControl,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS,
  ),
);

export const useTransportRouteSearchParams = (options?: Options) => {
  return options?.persisted ? persistedStore() : store();
};